import * as FluxUtils from 'flux/utils';

import { AppDispatcher, DispatcherBaseAction } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { ExportFormat } from '../constants/ExportFormats';

export type ToggleStoreState = Array<ExportFormat | 'IMAGE' | 'PDF'>;

class ToggleStoreClass extends FluxUtils.ReduceStore<ToggleStoreState, unknown> {
    public getInitialState(): ToggleStoreState {
        return ['PDF'];
    }

    public reduce(state: ToggleStoreState, action: DispatcherBaseAction): ToggleStoreState {
        // Note: this function should be `pure` -> we have to return a copy
        // of the current state if some property was changed

        // FixMe: remove duplicate code
        switch (action.actionType) {
            case ActionConstants.TOGGLE_VALUE:
                if (action.value) {
                    const index: number = state.indexOf(action.value);
                    const array: ToggleStoreState = state.slice(0);
                    if (index > -1) {
                        array.splice(index, 1);
                    } else {
                        array.push(action.value);
                    }
                    return array;
                }
                return state;
            default:
                break;
        }

        return state;
    }
}

export let ToggleStore: ToggleStoreClass = new ToggleStoreClass(AppDispatcher);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/ToggleStore.ts